import type { AsyncState } from '../../../platform/async/Async'
import type { Cashflow } from '../../cashflow/cashflowWire'
import { worstWeekday, type DailySpend } from '../../cashflow/useDailySpend'

export type HeatmapView = DailySpend & { worst: ReturnType<typeof worstWeekday> }

/**
 * The day heatmap's state. Until the cashflow report names a currency the daily
 * query cannot run, so the report's own loading or error is the widget's. No
 * per-day arithmetic here: each day is the server's figure. Only `worstWeekday`'s per-weekday sum
 * (`cashflow/dailySpend.ts`) remains, under the owner's exception on epic #3.
 */
export function toHeatmapState(period: AsyncState<Cashflow>, daily: AsyncState<DailySpend>): AsyncState<HeatmapView> {
  if (period.status !== 'success' && period.status !== 'stale') return period.status === 'error' ? period : { status: 'loading' }
  if (daily.status === 'success' || daily.status === 'stale') {
    return { status: 'success', data: { ...daily.data, worst: worstWeekday(daily.data.days, daily.data.currency) } }
  }
  return daily as AsyncState<HeatmapView>
}
